import { render, staticRenderFns } from "./paginationVue.vue?vue&type=template&id=5a484ca8"
import script from "./paginationVue.vue?vue&type=script&lang=js"
export * from "./paginationVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a484ca8')) {
      api.createRecord('5a484ca8', component.options)
    } else {
      api.reload('5a484ca8', component.options)
    }
    module.hot.accept("./paginationVue.vue?vue&type=template&id=5a484ca8", function () {
      api.rerender('5a484ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paginationVue.vue"
export default component.exports